module.exports = __webpack_public_path__ + "media/images/ADDress_logo-d1891753ad44517d325cbc66ec29fa6b.svg";